import { Option } from '../components/types';

const PaginationValues: string[] = ['10', '25', '50', '100'];

export const PAGINATION_OPTIONS_BASED: Option[] = PaginationValues.map((value) => ({ value, label: value }));
export const PAGINATION_OPTIONS: Option[] = ['2', '5', ...PaginationValues].map((value) => ({ value, label: value }));
